import { render, staticRenderFns } from "./TheTopbar.vue?vue&type=template&id=fa567a34&scoped=true&lang=html&"
import script from "./TheTopbar.vue?vue&type=script&lang=js&"
export * from "./TheTopbar.vue?vue&type=script&lang=js&"
import style0 from "./TheTopbar.vue?vue&type=style&index=0&id=fa567a34&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa567a34",
  null
  
)

export default component.exports